import { ICoproduct } from './ICoproduct';
import { IEconomicAttributeCollection } from './IEconomicAttributeCollection';
import { ICapCategory } from './ICapCategory';
import { IRotationEffect } from './Api/Response/RotationEffects/IRotationEffect';
import { IGroundTypeEffect } from './Api/Response/GroundTypeEffects/IGroundTypeEffect';

export enum EnumCultureSeason {
  none = '',
  summer = 'summer',
  winter = 'winter',
  spring = 'spring',
}

export const CultureSeasonLabels: Record<EnumCultureSeason, string> = {
  [EnumCultureSeason.none]: 'Aucune',
  [EnumCultureSeason.summer]: 'Été',
  [EnumCultureSeason.winter]: 'Hiver',
  [EnumCultureSeason.spring]: 'Printemps',
};

// Use this with i18next's t function: getCultureSeasonLabels(t)
export const getCultureSeasonLabels = (
  t: (key: string) => string,
): Record<EnumCultureSeason, string> => ({
  [EnumCultureSeason.none]: t('common.noneFeminine'),
  [EnumCultureSeason.summer]: t('cultureSeason.summer'),
  [EnumCultureSeason.winter]: t('cultureSeason.winter'),
  [EnumCultureSeason.spring]: t('cultureSeason.spring'),
});

export interface ICulture {
  id: number;
  name: string;
  parentCultureName?: string;
  parentCulture?: number;
  parentSectorCulture?: number;
  economicAttributeCollection: IEconomicAttributeCollection;
  color: string;
  price: number | null;
  priceN5: number | null;
  inputCost: number | null;
  inputCostN5: number | null;
  grossMargin: number;
  grossMarginN5: number;
  yield: number;
  ift: number;
  presenceDuration: number;
  prohibitionDuration: number;
  coProducts: ICoproduct[];
  coProduct: string[];
  yieldProduct: number[];
  irrigationYieldGain: number;
  irrigationWaterNeeded: number;
  capCategory: ICapCategory;
  cultureSeason: EnumCultureSeason;
  isStrawProducer: boolean;
  extraCost: number;
  isIrrigableOnly: boolean;
  isArable: boolean;
  extraBiomass: number;
  aerialBiomass: number;
  rootBiomass: number;
  metaCode: string;
  metaCultureName: string;
  rotationEffects?: IRotationEffect[];
  groundTypeEffects?: IGroundTypeEffect[];
  isCustomized?: boolean;
  isOrganic?: boolean;
  cultureType: string;
}
